import { useEffect } from 'react';

export function useCustomEventListener<K extends keyof WindowEventMap>(
  eventKey: K,
  handler: (event: WindowEventMap[K]) => void
) {
  useEffect(() => {
    const eventListener = (event: WindowEventMap[K]) => {
      handler(event);
    };

    window.addEventListener(eventKey, eventListener);
    return () => {
      window.removeEventListener(eventKey, eventListener);
    };
  }, [eventKey, handler]);
}
